module.exports = __webpack_public_path__ + "img/qrcode.0f63c2c9.jpg";